import { render } from "./ChooseProduct.vue?vue&type=template&id=4bfc29f1&scoped=true"
import script from "./ChooseProduct.vue?vue&type=script&lang=js"
export * from "./ChooseProduct.vue?vue&type=script&lang=js"

import "./ChooseProduct.vue?vue&type=style&index=0&id=4bfc29f1&lang=scss&scoped=true"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfc29f1"]])

export default __exports__